import React, { createContext, useContext, useState, useCallback } from 'react'

interface LyraEditorContext {
  project_name?: string
  language_pair?: string
  segment_source?: string
  segment_target?: string
  segment_index?: number
  tm_match_score?: number
}

interface LyraContextValue {
  editorContext: LyraEditorContext
  setEditorContext: (ctx: LyraEditorContext) => void
  clearEditorContext: () => void
  lyraOpen: boolean
  lyraResetKey: number
  resetLyraMessages: () => void
  setLyraOpen: (open: boolean) => void
  onApplySegmentEdit: ((order: number, text: string) => void) | null
  setOnApplySegmentEdit: (fn: ((order: number, text: string) => void) | null) => void
}

const LyraContext = createContext<LyraContextValue>({
  editorContext: {},
  setEditorContext: () => {},
  clearEditorContext: () => {},
  lyraOpen: false,
  lyraResetKey: 0,
  resetLyraMessages: () => {},
  setLyraOpen: () => {},
  onApplySegmentEdit: null,
  setOnApplySegmentEdit: () => {},
})

export function LyraProvider({ children }: { children: React.ReactNode }) {
  const [editorContext, setEditorContextState] = useState<LyraEditorContext>({})
  const [lyraOpen, setLyraOpen] = useState(false)
  const [lyraResetKey, setLyraResetKey] = useState(0)
  const [onApplySegmentEdit, setOnApplySegmentEdit] = useState<((order: number, text: string) => void) | null>(null)

  const setEditorContext = useCallback((ctx: LyraEditorContext) => {
    setEditorContextState(ctx)
  }, [])

  const clearEditorContext = useCallback(() => {
    setEditorContextState({})
  }, [])

  return (
    <LyraContext.Provider value={{ editorContext, setEditorContext, clearEditorContext, lyraOpen, setLyraOpen, lyraResetKey, resetLyraMessages: () => setLyraResetKey(k => k+1), onApplySegmentEdit, setOnApplySegmentEdit }}>
      {children}
    </LyraContext.Provider>
  )
}

export function useLyraContext() {
  return useContext(LyraContext)
}
